<template>
  <div class="mb-20" v-if="isLoading">
    <AppLoading />
  </div>
  <slot v-else></slot>
</template>

<script setup>
import { ref, defineExpose } from 'vue';

const isLoading = ref(true);
defineExpose({ isLoading });
</script>
